import MuiInputLabel from '@mui/material/InputLabel';
import { alpha, styled } from '@mui/material/styles';

export const StyledInputLabel = styled(MuiInputLabel)(({ theme }) => ({
  '&.Mui-focused': {
    fontWeight: 600,
  },
  '&:focus-visible': {
    outline: `3px solid ${alpha(theme.palette.primary.main, 0.28)}`,
    outlineOffset: 2,
  },
})) as typeof MuiInputLabel;
